import type { ObjectMapping } from '@shared/types/utils';

export const ACTION_TYPE: ObjectMapping = {
  UNSET_ACTION_TYPE: 'UNSET_ACTION_TYPE',

  PAGE_LOAD: 'PAGE_LOAD',
  SEARCH_STARTED: 'SEARCH_STARTED',
  SEARCH_FINISHED: 'SEARCH_FINISHED',
  DAY_VIEW_SEARCH: 'DAY_VIEW_SEARCH',
  HOME_PAGE_SEARCH: 'HOME_PAGE_SEARCH',
  DAY_VIEW_HOTEL_CARD_CLICKED: 'DAY_VIEW_HOTEL_CARD_CLICKED',
  DAY_VIEW_META_REDIRECT: 'DAY_VIEW_META_REDIRECT',
  DAY_VIEW_FILTERS_USED: 'DAY_VIEW_FILTERS_USED',
  DAY_VIEW_SORT_USED: 'DAY_VIEW_SORT_USED',
  SEARCH_RESULT_SELECTED: 'SEARCH_RESULT_SELECTED',
  PRICES_LOADED: 'PRICES_LOADED',
  ROOM_INFO_MODAL_BUTTON_CLICKED: 'ROOM_INFO_MODAL_BUTTON_CLICKED',
  ROOM_INFO_MODAL_CLICKED: 'ROOM_INFO_MODAL_CLICKED',
  DIRECT_MODAL_CLICKED: 'DIRECT_MODAL_CLICKED',
  PRICE_BREAK_DOWN_MODAL_CLICKED: 'PRICE_BREAK_DOWN_MODAL_CLICKED',
  PRICE_DBOOK_SELECTED: 'PRICE_DBOOK_SELECTED',
  PRICE_META_SELECTED: 'PRICE_META_SELECTED',
  PRICE_SELECTED: 'PRICE_SELECTED',
  MOST_POPULAR_RATE_CARD_CLICKED: 'MOST_POPULAR_RATE_CARD_CLICKED',
  BEST_OFFER_RATE_CARD_CLICKED: 'BEST_OFFER_RATE_CARD_CLICKED',
  MAIN_CTA_BUTTON_CLICKED: 'MAIN_CTA_BUTTON_CLICKED',
  MOST_POPULAR_PRICES_MODAL_BUTTON_CLICKED:
    'MOST_POPULAR_PRICES_MODAL_BUTTON_CLICKED',
  RATE_BOOK_BUTTON_CLICKDED: 'RATE_BOOK_BUTTON_CLICKDED',
  SPECIFIC_RATE_BOOK_DBOOK_BUTTON_CLICKED:
    'SPECIFIC_RATE_BOOK_DBOOK_BUTTON_CLICKED',
  DBOOK_CLICK: 'DBOOK_CLICK',
  AVAILABLE_DEALS_CLICKED: 'AVAILABLE_DEALS_CLICKED',
  MOST_POPULAR_RATE_CARD_DBOOK_CLICKED: 'MOST_POPULAR_RATE_CARD_DBOOK_CLICKED',
  MOST_POPULAR_RATE_CARD_META_CLICKED: 'MOST_POPULAR_RATE_CARD_META_CLICKED',
  MOST_POPULAR_PRICES_MODAL_SELECT_ROOM_BUTTON_CLICKED:
    'MOST_POPULAR_PRICES_MODAL_SELECT_ROOM_BUTTON_CLICKED',
  BEST_OFFER_DBOOK_RATE_CARD_CLICKED: 'BEST_OFFER_DBOOK_RATE_CARD_CLICKED',
  BEST_OFFER_META_RATE_CARD_CLICKED: 'BEST_OFFER_META_RATE_CARD_CLICKED',
  MAIN_CTA_DBOOK_BUTTON_CLICKED: 'MAIN_CTA_DBOOK_BUTTON_CLICKED',
  MAIN_CTA_META_BUTTON_CLICKED: 'MAIN_CTA_META_BUTTON_CLICKED',
  MOST_POPULAR_PRICES_MODAL_GO_TO_SITE_BUTTON_CLICKED:
    'MOST_POPULAR_PRICES_MODAL_GO_TO_SITE_BUTTON_CLICKED',
  CHECKOUT_FORM_BOOK_BUTTON_CLICKED: 'CHECKOUT_FORM_BOOK_BUTTON_CLICKED',
  YOUR_DETAILS_NEXT_BUTTON_CLICKED: 'YOUR_DETAILS_NEXT_BUTTON_CLICKED',
  HOTELS_HOME_PAGE_LOAD: 'HOTELS_HOME_PAGE_LOAD',
  HOTELS_RESULTS_PAGE_LOAD: 'HOTELS_RESULTS_PAGE_LOAD',
  HOTELS_DBOOK_PAGE_LOAD: 'HOTELS_DBOOK_PAGE_LOAD',
  HOTELS_IN_CITY_PAGE_LOAD: 'HOTELS_IN_CITY_PAGE_LOAD',
  STAR_HOTELS_IN_CITY_PAGE_LOAD: 'STAR_HOTELS_IN_CITY_PAGE_LOAD',
  HOTELS_IN_NEIGHBOURHOOD_PAGE_LOAD: 'HOTELS_IN_NEIGHBOURHOOD_PAGE_LOAD',
  HOTELS_DETAILS_PAGE_LOAD: 'HOTELS_DETAILS_PAGE_LOAD',
  HOTELS_DEALS_PAGE_LOAD: 'HOTELS_DEALS_PAGE_LOAD',
  DAY_VIEW_HOTEL_RECOMMEND_CARD_CLICKED:
    'DAY_VIEW_HOTEL_RECOMMEND_CARD_CLICKED',
  DAY_VIEW_HOTEL_RECOMMEND_TAG_CLICKED: 'DAY_VIEW_HOTEL_RECOMMEND_TAG_CLICKED',
  DAY_VIEW_HOTEL_RECOMMEND_CLOSE_CLICKED:
    'DAY_VIEW_HOTEL_RECOMMEND_CLOSE_CLICKED',
  VIEWED_HOTEL_CITY_FILTER_CLICK: 'VIEWED_HOTEL_CITY_FILTER_CLICK',
  VIEWED_HOTEL_VIEW_ALL_CLICK: 'VIEWED_HOTEL_VIEW_ALL_CLICK',
  VIEWED_HOTEL_CLEAR_MODAL_CLICK: 'VIEWED_HOTEL_CLEAR_MODAL_CLICK',
  VIEWED_HOTEL_STAY_EDIT: 'VIEWED_HOTEL_STAY_EDIT',
  VIEWED_HOTEL_VIEW_ENTRANCE_CLICK: 'VIEWED_HOTEL_VIEW_ENTRANCE_CLICK',
  VIEWED_HOTEL_CLEAR_CLICK: 'VIEWED_HOTEL_CLEAR_CLICK',
  VIEWED_HOTEL_CLEAR_CANCEL_CLICK: 'VIEWED_HOTEL_CLEAR_CANCEL_CLICK',
  VIEWED_HOTEL_HIDE_CLICK: 'VIEWED_HOTEL_HIDE_CLICK',
  VIEWED_HOTEL_SHOW_CLICK: 'VIEWED_HOTEL_SHOW_CLICK',
  VIEWED_HOTELS_PAGE_LOAD: 'VIEWED_HOTELS_PAGE_LOAD',
  DETAIL_PAGE_NEARBY_MAP_CLICK: 'DETAIL_PAGE_NEARBY_MAP_CLICK',
  MWEB_NEW_DAY_VIEW_MAP_CLICK: 'MWEB_NEW_DAY_VIEW_MAP_CLICK',
  DAY_VIEW_PAGINATION_CLICK: 'DAY_VIEW_PAGINATION_CLICK',
  DAY_VIEW_MAP_PANEL_CLICK: 'DAY_VIEW_MAP_PANEL_CLICK',
  HOTEL_DETAIL_ADDRESS_CLICK: 'HOTEL_DETAIL_ADDRESS_CLICK',
  HOTEL_DETAIL_RECOMMEND_HOTEL_CHIP_CLICK:
    'HOTEL_DETAIL_RECOMMEND_HOTEL_CHIP_CLICK',
  DAY_VIEW_MAP_SEARCH_CITY_CHANGE: 'DAY_VIEW_MAP_SEARCH_CITY_CHANGE',
  SEARCH_SYNC_MAP_CHECKBOX_CLICK: 'SEARCH_SYNC_MAP_CHECKBOX_CLICK',
  DAY_VIEW_MAP_SEARCH_THIS_AREA_CLICK: 'DAY_VIEW_MAP_SEARCH_THIS_AREA_CLICK',
  FIND_THESE_GREAT_DEALS_RENDERED: 'FIND_THESE_GREAT_DEALS_RENDERED',
  FIND_THESE_GREAT_DEALS_CLICKED: 'FIND_THESE_GREAT_DEALS_CLICKED',
  DETAILS_CLOSE_POIS_CARD_CLICKED: 'DETAILS_CLOSE_POIS_CARD_CLICKED',
  DETAILS_RATES_FILTER_CLICK: 'DETAILS_RATES_FILTER_CLICK',
  AUTO_SUGGEST_POIS_RENDER: 'AUTO_SUGGEST_POIS_RENDER',
  AUTO_SUGGEST_POIS_CLICK: 'AUTO_SUGGEST_POIS_CLICK',
  AUTO_SUGGEST_RECENT_SEARCH_RENDER: 'AUTO_SUGGEST_RECENT_SEARCH_RENDER',
  VIEW_BUTTON_CLICKED: 'VIEW_BUTTON_CLICKED',
  BASE_ROOM_TYPE_FILTER_CLICKED: 'BASE_ROOM_TYPE_FILTER_CLICKED',
  SEARCH_RESULT_LOADED: 'SEARCH_RESULT_LOADED',
  BOOKING_PROCESS_STATE: 'BOOKING_PROCESS_STATE',
  BOOKING_PERFORMED: 'BOOKING_PERFORMED',
  MAP_ACTIVE_DAY_VIEW: 'MAP_ACTIVE_DAY_VIEW',
  MAP_MOVING_DAY_VIEW: 'MAP_MOVING_DAY_VIEW',
  POI_MENU_OPEN_DAY_VIEW: 'POI_MENU_OPEN_DAY_VIEW',
  POI_MENU_SELECT_DAY_VIEW: 'POI_MENU_SELECT_DAY_VIEW',
  POI_SEARCH_DAY_VIEW: 'POI_SEARCH_DAY_VIEW',
  VIEWED_HOTELS_DATA_LOADED: 'VIEWED_HOTELS_DATA_LOADED',
  PRICES_LOADED_META_ONLY: 'PRICES_LOADED_META_ONLY',
  PRICES_LOADED_DBOOK_ONLY: 'PRICES_LOADED_DBOOK_ONLY',
  PRICES_LOADED_HYBRID: 'PRICES_LOADED_HYBRID',
  HOTEL_PRICES_STATUS: 'HOTEL_PRICES_STATUS',
  MAP_HOTEL_MARKER_CLICK: 'MAP_HOTEL_MARKER_CLICK',
  UNIFIED_PAYMENT_INTEGRATION: 'UNIFIED_PAYMENT_INTEGRATION',
  LOGIN_DEAL_PROCESS: 'LOGIN_DEAL_PROCESS',
  PRE_CHECK_STATE: 'PRE_CHECK_STATE',
  DEALS_NAV_CLICKED: 'DEALS_NAV_CLICKED',
  HOTEL_DETAIL_SEARCH: 'HOTEL_DETAIL_SEARCH',
  HOTEL_DEALS_SEARCH: 'HOTEL_DEALS_SEARCH',
  SEARCH_CONDITION_CHANGED: 'SEARCH_CONDITION_CHANGED',
  DEALS_SHARE_CLICKED: 'DEALS_SHARE_CLICKED',
  CHECKOUT_USER_ACTION: 'CHECKOUT_USER_ACTION',
  DETAILS_REVIEW_FILTER_CLICKED: 'DETAILS_REVIEW_FILTER_CLICKED',
  CROSS_LINK_CLICKED: 'CROSS_LINK_CLICKED',
  TRANSLATION_BUTTON_CLICKED: 'TRANSLATION_BUTTON_CLICKED',
  QUICK_FILTER_GROUP_CLICKED: 'QUICK_FILTER_GROUP_CLICKED',
  DAY_VIEW_FILTERS_ENTRY_CLICK: 'DAY_VIEW_FILTERS_ENTRY_CLICK',
  DAYVIEW_PAGE_FILTER_BUTTON_CLICK: 'DAYVIEW_PAGE_FILTER_BUTTON_CLICK',
  DAYVIEW_PAGE_FILTER_BUTTON_LOADED: 'DAYVIEW_PAGE_FILTER_BUTTON_LOADED',
  DETAILS_REVIEW_SECTION_SEEN: 'DETAILS_REVIEW_SECTION_SEEN',
  DETAILS_REVIEW_PAGINATION_CLICK: 'DETAILS_REVIEW_PAGINATION_CLICK',
  CHECKOUT_MULTI_ROOMS_ACTION: 'CHECKOUT_MULTI_ROOMS_ACTION',
  MARKETING_OPT_IN_PROCESS: 'MARKETING_OPT_IN_PROCESS',
  TRIP_PAYMENT_SKIPPY_PAGE_LOADED: 'TRIP_PAYMENT_SKIPPY_PAGE_LOADED',
  SEO_HOTEL_DETAILS_PAGE_LOAD: 'SEO_HOTEL_DETAILS_PAGE_LOAD',
  META_PUSH_LOGIN_PROCESS: 'META_PUSH_LOGIN_PROCESS',
  PRICE_SEEN: 'PRICE_SEEN',
  REDIRECT_ACTION: 'REDIRECT_ACTION',
  SEARCH_EMPTY: 'SEARCH_EMPTY',
  SAVE_STATUS_CHANGED: 'SAVE_STATUS_CHANGED',
  SAVE_NOTIFICATION_CLICKED: 'SAVE_NOTIFICATION_CLICKED',
  DAY_VIEW_HOTEL_REWARD_PRICE_BANNER_LOADED:
    'DAY_VIEW_HOTEL_REWARD_PRICE_BANNER_LOADED',
  DAY_VIEW_HOTEL_REWARD_PRICE_BANNER_CLICKED:
    'DAY_VIEW_HOTEL_REWARD_PRICE_BANNER_CLICKED',
  DAY_VIEW_HOTEL_REWARD_PRICE_POPUP_LOADED:
    'DAY_VIEW_HOTEL_REWARD_PRICE_POPUP_LOADED',
  DAY_VIEW_HOTEL_REWARD_PRICE_POPUP_CLICKED:
    'DAY_VIEW_HOTEL_REWARD_PRICE_POPUP_CLICKED',
  DAY_VIEW_HOTEL_REWARD_PRICE_POPUP_CLOSED:
    'DAY_VIEW_HOTEL_REWARD_PRICE_POPUP_CLOSED',
  PRICE_BREAKDOWN_SELECTED: 'PRICE_BREAKDOWN_SELECTED',
  HOTEL_MEDIA_GALLERY_CLICKED: 'HOTEL_MEDIA_GALLERY_CLICKED',
  PRICE_RANGES_VIEW: 'PRICE_RANGES_VIEW',
  MORE_FROM_CLICKED: 'MORE_FROM_CLICKED',
  NEIGHBOURHOODS_CHIP_GROUP_SEEN: 'NEIGHBOURHOODS_CHIP_GROUP_SEEN',
  ALTERNATIVE_DATES_OPTION_SEARCH: 'ALTERNATIVE_DATES_OPTION_SEARCH',
  ALTERNATIVE_DATES_OPTION_CLICK: 'ALTERNATIVE_DATES_OPTION_CLICK',
  CHAT_BOX_ENTRY_CLICK: 'CHAT_BOX_ENTRY_CLICK',
  APPLY_CHAT_FILTERS_LOADED: 'APPLY_CHAT_FILTERS_LOADED',
  APPLY_CHAT_FILTERS_CLICK: 'APPLY_CHAT_FILTERS_CLICK',
  ATYPICAL_DEALS_CAROUSEL_HOTEL_CARD_CLICK:
    'ATYPICAL_DEALS_CAROUSEL_HOTEL_CARD_CLICK',
  AI_FILTER_SUMMARY_CLOSED: 'AI_FILTER_SUMMARY_CLOSED',
  CHAT_BOX_ENTRY_LOADED: 'CHAT_BOX_ENTRY_LOADED',
  ATYPICAL_DEALS_CAROUSEL_HOTEL_CARD_SEEN:
    'ATYPICAL_DEALS_CAROUSEL_HOTEL_CARD_SEEN',
  NEIGHBOURHOOD_SNAPSHOT_SEEN: 'NEIGHBOURHOOD_SNAPSHOT_SEEN',
  NEIGHBOURHOOD_SNAPSHOT_PRICE_RANGE_USED:
    'NEIGHBOURHOOD_SNAPSHOT_PRICE_RANGE_USED',
  NEIGHBOURHOOD_SNAPSHOT_CARD_SWIPED: 'NEIGHBOURHOOD_SNAPSHOT_CARD_SWIPED',
  NEIGHBOURHOOD_SNAPSHOT_CLICKED: 'NEIGHBOURHOOD_SNAPSHOT_CLICKED',
  NEIGHBOURHOOD_SNAPSHOT_APPLIED: 'NEIGHBOURHOOD_SNAPSHOT_APPLIED',
  NEIGHBOURHOOD_SNAPSHOT_COLLAPSED: 'NEIGHBOURHOOD_SNAPSHOT_COLLAPSED',
  NEIGHBOURHOOD_SNAPSHOT_EXPANDED: 'NEIGHBOURHOOD_SNAPSHOT_EXPANDED',
  NEIGHBOURHOOD_SNAPSHOT_PRICE_EXPLANATION_VIEWED:
    'NEIGHBOURHOOD_SNAPSHOT_PRICE_EXPLANATION_VIEWED',
};

export const PANEL_POSITION: ObjectMapping = {
  UNSET_PANEL_POSITION: 'UNSET_PANEL_POSITION',
  BOOKING_PANEL: 'BOOKING_PANEL',
  TOP_PANEL_MOBILE: 'TOP_PANEL_MOBILE',
};

export const CLICK_AREA: ObjectMapping = {
  UNSET_CLICK_AREA: 'UNSET_CLICK_AREA',
  CITY_FILTER: 'CITY_FILTER',
  CITY_FILTER_IN_FULL_PAGE: 'CITY_FILTER_IN_FULL_PAGE',
  DETAIL_VIEW_DETAILS: 'DETAIL_VIEW_DETAILS',
  DETAIL_VIEW_MORE: 'DETAIL_VIEW_MORE',
  DETAIL_VIEW_LESS: 'DETAIL_VIEW_LESS',
  DETAIL_RATE_CARD_CTA_BOOK: 'DETAIL_RATE_CARD_CTA_BOOK',
  DETAIL_RATE_DETAILS_MODAL_BOOK: 'DETAIL_RATE_DETAILS_MODAL_BOOK',
  DETAIL_RATE_PRICE_MODAL_BOOK: 'DETAIL_RATE_PRICE_MODAL_BOOK',
  DEALS_VIEW_MORE: 'DEALS_VIEW_MORE',
  REVIEWS_TAB: 'REVIEWS_TAB',
  AMENITIES_TAB: 'AMENITIES_TAB',
  DETAIL_FACEBOOK_SHARE: 'DETAIL_FACEBOOK_SHARE',
  DETAIL_TWITTER_SHARE: 'DETAIL_TWITTER_SHARE',
  DETAIL_HOTEL_LINK_SHARE: 'DETAIL_HOTEL_LINK_SHARE',
  DEALS_WHATSAPP_SHARE: 'DEALS_WHATSAPP_SHARE',
  DEALS_LINKEDIN_SHARE: 'DEALS_LINKEDIN_SHARE',
  DEALS_TELEGRAM_SHARE: 'DEALS_TELEGRAM_SHARE',
  DETAIL_VIEW_MORE_ROOMS: 'DETAIL_VIEW_MORE_ROOMS',
  DETAIL_VIEW_LESS_ROOMS: 'DETAIL_VIEW_LESS_ROOMS',
  DETAIL_VIEW_MORE_POLICY_GROUPS: 'DETAIL_VIEW_MORE_POLICY_GROUPS',
  DETAIL_VIEW_LESS_POLICY_GROUPS: 'DETAIL_VIEW_LESS_POLICY_GROUPS',
  DETAIL_GENERAL_CTA: 'DETAIL_GENERAL_CTA',
  DETAIL_REVIEW_TRANSLATION_BUTTON: 'DETAIL_REVIEW_TRANSLATION_BUTTON',
  DETAIL_SAVE_ICON: 'DETAIL_SAVE_ICON',
  DV_CARD: 'DV_CARD',
  VIEW_MORE_ROOM_AMENITIES: 'VIEW_MORE_ROOM_AMENITIES',
  META_PUSH_LOGIN_PROCESS: 'META_PUSH_LOGIN_PROCESS',
  SIMPLIFIED_RATE_CARD: 'SIMPLIFIED_RATE_CARD',
  NORMAL_RATE_CARD: 'NORMAL_RATE_CARD',
  MOST_POPULAR_RATE_CARD: 'MOST_POPULAR_RATE_CARD',
  MAIN_CTA_CARD: 'MAIN_CTA_CARD',
  RATE_CARD_IN_MODAL: 'RATE_CARD_IN_MODAL',
  BEST_OFFER_RATE_CARD: 'BEST_OFFER_RATE_CARD',
  SPECIFIC_SELECT_BUTTON: 'SPECIFIC_SELECT_BUTTON',
  ROOM_SELECTION_SELECT_BUTTON: 'ROOM_SELECTION_SELECT_BUTTON',
  LOWESTPRICEBTN: 'INVENTORY_CARD_LOWEST_PRICE_BUTTON',
  OTHER: 'INVENTORY_CARD_OTHER_RATE_CTA',
  SECONDARY: 'INVENTORY_CARD_SECONDARY_CONTENT',
  REVIEWS_TRAVELLER_IMAGE: 'REVIEWS_TRAVELLER_IMAGE',
  DV_VIEW_ALL: 'DV_VIEW_ALL',
  PRICE_RANGES_EXPAND_BUTTON: 'PRICE_RANGES_EXPAND_BUTTON',
  MORE_FROM_CARD: 'MORE_FROM_CARD',
  MORE_FROM_BUTTON: 'MORE_FROM_BUTTON',
  MORE_FROM_REDIRECT: 'MORE_FROM_REDIRECT',
  PRICE_RANGES_DETAILS_EXPAND_BUTTON: 'PRICE_RANGES_DETAILS_EXPAND_BUTTON',
  PRICE_RANGES_INFO_ICON_BUTTON: 'PRICE_RANGES_INFO_ICON_BUTTON',
  PRICE_RANGES_DETAILS_INFO_ICON_BUTTON:
    'PRICE_RANGES_DETAILS_INFO_ICON_BUTTON',
  RATING_STATEMENT: 'RATING_STATEMENT',
  CAROUSEL_HOTELS_PANEL_COLLAPSE_BUTTON:
    'CAROUSEL_HOTELS_PANEL_COLLAPSE_BUTTON',
  CAROUSEL_HOTELS_CARD_INFO_ICON_BUTTON:
    'CAROUSEL_HOTELS_CARD_INFO_ICON_BUTTON',
};

export const ROOM_TYPE: ObjectMapping = {
  UNSET_ROOM_TYPE: 'UNSET_ROOM_TYPE',
  GENERIC_ROOM: 'ROOM_TYPE_GENERIC_ROOM',
  SINGLE_ROOM: 'ROOM_TYPE_SINGLE_ROOM',
  DOUBLE_ROOM: 'ROOM_TYPE_DOUBLE_ROOM',
  TWIN_ROOM: 'ROOM_TYPE_TWIN_ROOM',
  TRIPLE_ROOM: 'ROOM_TYPE_TRIPLE_ROOM',
  SHARED_ROOM: 'ROOM_TYPE_SHARED_ROOM',
  FAMILY_ROOM: 'ROOM_TYPE_FAMILY_ROOM',
  SUITE_ROOM: 'ROOM_TYPE_SUITE_ROOM',
  JAPANESE_STYLE_ROOM: 'ROOM_TYPE_JAPANESE_STYLE_ROOM',
  JAPANESE_BED_ROOM: 'ROOM_TYPE_JAPANESE_BED_ROOM',
};

export const PRICE_TYPE: ObjectMapping = {
  UNSET_PRICE_TYPE: 'UNSET_PRICE_TYPE',
  DBOOK: 'DBOOK',
  META: 'META',
  FSS: 'FSS',
};

export const FILTER_TYPE: ObjectMapping = {
  UNSET_FILTER_TYPE: 'UNSET_FILTER_TYPE',
  CONFIDENT_TYPES: 'CONFIDENT_TYPE_FILTER',
  PRICE: 'PRICE_FILTER',
  STARS: 'STARS_FILTER',
  PROPERTY_TYPE: 'PROPERTY_TYPE_FILTER',
  CANCELLATION: 'CANCELLATION_FILTER',
  MEAL_PLAN: 'MEAL_PLAN_FILTER',
  RATING: 'RATING_FILTER',
  DISCOUNT_TYPES: 'DISCOUNT_TYPE_FILTER',
  AMENITIES: 'AMENITIES_FILTER',
  GUEST_TYPE: 'GUEST_TYPE_FILTER',
  CHAIN: 'CHAIN_FILTER',
  DISTRICT: 'DISTRICT_FILTER',
  LOCALE: 'LOCALE_FILTER',
  SORT_TYPE: 'SORT_TYPE_FILTER',
  TAG: 'TAG_FILTER',
  POPULAR_FILTER: 'POPULAR_FILTER',
  REVIEW_PROVIDER: 'REVIEW_PROVIDER_FILTER',
  GUEST_RATING: 'GUEST_RATING',
  PRICE_TYPE: 'PRICE_TYPE_FILTER',
  VIBES: 'VIBES_FILTER',
};

export const REGION: ObjectMapping = {
  UNSET_REGION: 'UNSET_DEPLOY_COLOUR',
  EU_WEST_1: 'EU_WEST_1',
  EU_CENTRAL_1: 'EU_CENTRAL_1',
  AP_SOUTHEAST_1: 'AP_SOUTHEAST_1',
  AP_NORTHEAST_1: 'AP_NORTHEAST_1',
};

export const DEVICE: ObjectMapping = {
  UNSET_DEVICE: 'UNSET_DEVICE',
  TABLET: 'TABLET_WEB',
  DESKTOP: 'DESKTOP_WEB',
  MOBILE: 'MOBILE_WEB',
  IOS: 'IOS',
  ANDROID: 'ANDROID',
};

export const CLICK_TYPE: ObjectMapping = {
  UNSET_POI_TYPE: 'UNSET_POI_TYPE',
  MAP_VIEW: 'MAP_VIEW',
  MAP_VIEW_MARKER: 'MAP_VIEW_MARKER',
  GOOD_POINT: 'GOOD_POINT',
  TRANSPORTATION: 'TRANSPORTATION',
  AIRPORT: 'AIRPORT',
  CITY_CENTER: 'CITY_CENTRE',
  NEAREST_POINT: 'NEAREST_POINT',
  NEAREST_TRANSPORTATION: 'NEAREST_TRANSPORTATION',
  NEAREST_AIRPORT: 'NEAREST_AIRPORT',
  ADDRESS: 'ADDRESS',
  NEARBY_HOTEL: 'NEARBY_HOTEL',
  LANDMARK: 'LANDMARK',
  ENTERTAINMENT: 'ENTERTAINMENT',
  SHOPPING: 'SHOPPING',
  EDUCATION: 'EDUCATION',
};

export const ENTITY_TYPE: ObjectMapping = {
  UNSET_ENTITY_TYPE: 'UNSET_ENTITY_TYPE',
  HOTEL: 'SPECIFIC_HOTEL',
  CITY: 'CITY',
  DISTRICT: 'DISTRICT',
  NATION: 'NATION',
  TERRITORY: 'TERRITORY',
  ISLAND: 'ISLAND',
  OCEAN: 'OCEAN',
  REGION: 'REGION',
  FIRSTLEVELNATIONADMINISTRATIVEDIVISION: 'FIRST_ADMINISTRATIVE_DIVISION',
  SECONDLEVELNATIONADMINISTRATIVEDIVISION: 'SECOND_ADMINISTRATIVE_DIVISION',
  THIRDLEVELNATIONADMINISTRATIVEDIVISION: 'THIRD_ADMINISTRATIVE_DIVISION',
  AMUSEMENTPARK: 'AMUSEMENT_PARK',
  BEACH: 'BEACH',
  BUSSTATION: 'BUS_STATION',
  CAMPGROUND: 'CAMPGROUND',
  CARPARKINDOORS: 'CAR_PARK_INDOORS',
  CARPARKOUTDOORS: 'CAR_PARK_OUTDOORS',
  CARPARK: 'CAR_PARK',
  CARRENTAL: 'CAR_RENTAL',
  CASINOBUILDING: 'CASINO_BUILDING',
  CINEMAHALL: 'CINEMA_HALL',
  CONCERTHALL: 'CONCERT_HALL',
  CONVENTIONHALL: 'CONVENTION_HALL',
  COURTHOUSE: 'COURTHOUSE',
  CULTURALCENTERBUILDING: 'CULTURAL_CENTER_BUILDING',
  EMBASSYBUILDING: 'EMBASSY_BUILDING',
  EXHIBITIONCENTERBUILDING: 'EXHIBITION_CENTER_BUILDING',
  FRONTIERCROSSING: 'FRONTIER_CROSSING',
  GOLFCOURSE: 'GOLF_COURSE',
  GOVERNMENTBUILDING: 'GOVERNMENT_BUILDING',
  HARBOR: 'HARBOR',
  HISTORICSITE: 'HISTORIC_SITE',
  HOSPITAL: 'HOSPITAL',
  LEISURECENTERBUILDING: 'LEISURE_CENTER_BUILDING',
  LIBRARY: 'LIBRARY',
  MONUMENTLANDMARK: 'MONUMENT_LANDMARK',
  MOUNTAINPASS: 'MOUNTAIN_PASS',
  MOUNTAINPEAK: 'MOUNTAIN_PEAK',
  MUSEUM: 'MUSEUM',
  OPERAHALL: 'OPERA_HALL',
  PARK: 'PARK',
  RELIGIOUSBUILDING: 'RELIGIOUS_BUILDING',
  SHOPPINGMALL: 'SHOPPING_MALL',
  SKISTATION: 'SKI_STATION',
  SPORTSFACILITY: 'SPORTS_FACILITY',
  STADIUM: 'STADIUM',
  THEATREHALL: 'THEATRE_HALL',
  TOURISTATTRACTION: 'TOURIST_ATTRACTION',
  TOURISTINFORMATIONOFFICE: 'TOURIST_INFORMATION_OFFICE',
  TRAINSTATION: 'TRAIN_STATION',
  TRANSITWAYPLAZA: 'TRANSITWAY_PLAZA',
  METROSTATION: 'METRO_STATION',
  UNIVERSITYBUILDING: 'UNIVERSITY_BUILDING',
  ZOO: 'ZOO',
  ARTCENTER: 'ART_CENTER',
  ARTGALLERY: 'ART_GALLERY',
  BRIDGE: 'BRIDGE',
  CANYON: 'CANYON',
  CASTLE: 'CASTLE',
  CAVE: 'CAVE',
  DESERT: 'DESERT',
  FARM: 'FARM',
  FERRISWHEEL: 'FERRIS_WHEEL',
  FILMSTUDIO: 'FILM_STUDIO',
  FOREST: 'FOREST',
  FOUNTAIN: 'FOUNTAIN',
  GARDEN: 'GARDEN',
  GEOPARK: 'GEOPARK',
  GRASSLAND: 'GRASSLAND',
  HOTSPRING: 'HOT_SPRING',
  LAKE: 'LAKE',
  MODERNARCHITECTURE: 'MODERN_ARCHITECTURE',
  NATURERESERVE: 'NATURE_RESERVE',
  RIVER: 'RIVER',
  SCHOOL: 'SCHOOL',
  SPRING: 'SPRING',
  VOLCANO: 'VOLCANO',
  WATERFALL: 'WATERFALL',
  WETLAND: 'WETLAND',
  WORKSHOP: 'WORKSHOP',
};

export const AUTO_SUGGEST_POI_LIST = [
  'poi_id_one',
  'poi_id_two',
  'poi_id_three',
  'poi_id_four',
  'poi_id_five',
];

export const CUG_TYPE: ObjectMapping = {
  UNSET_CLOSED_USER_GROUP: 'UNSET_CLOSED_USER_GROUP',
  UNSET_CUG_TYPE: 'UNSET_CUG_TYPE',
  MOBILE: 'MOBILE',
  LOGGED_IN: 'LOGGED_IN',
  GENERAL: 'GENERAL',
  FLIGHT_BOOKED: 'FLIGHT_BOOKED',
  FLIGHT_CUSTOMER: 'FLIGHT_CUSTOMER',
  HOT_DEAL: 'HOT_DEAL',
  HOTEL_BOOKED: 'HOTEL_BOOKED',
  HOTEL_CUSTOMER: 'HOTEL_CUSTOMER',
  CAR_BOOKED: 'CAR_BOOKED',
  CAR_CUSTOMER: 'CAR_CUSTOMER',
  LOYALTY: 'LOYALTY',
  FLIGHT_SEARCH: 'FLIGHT_SEARCH',
  HOTEL_SEARCH: 'HOTEL_SEARCH',
  CAR_SEARCH: 'CAR_SEARCH',
  CAMPAIGN_DEAL: 'CAMPAIGN_DEAL',
  FLIGHT_CUSTOMER_PKG: 'FLIGHT_CUSTOMER_PKG',
  FLIGHT_BOOKED_PKG: 'FLIGHT_BOOKED_PKG',
  DD: 'DIRECT_DISCOUNT_TYPE',
};

export const HOTEL_CARD_AREA: ObjectMapping = {
  UNSET_HOTEL_CARD_AREA: 'UNSET_HOTEL_CARD_AREA',
  MAP_PANEL: 'MAP_PANEL',
  RECOMMENDED: 'RECOMMENDED',
  VIEWED: 'VIEWED',
  DEALS_PAGE: 'DEALS_PAGE',
  MAP_CARD_LIST: 'MAP_CARD_LIST',
};

export const PRICE_INFO_CARD_AREA: ObjectMapping = {
  UNSET_CARD_AREA: 'UNSET_CARD_AREA',
  MAP_CARD_LIST: 'MAP_CARD_LIST',
};

export const DAY_VIEW_MAP_CLICK_AREA: ObjectMapping = {
  TOP_BANNER: 'TOP_BANNER',
  STICKY_BUTTON: 'STICKY_BUTTON',
};

export const POI_MAP_CLICK_AREA: ObjectMapping = {
  POI_MENU: 'POI_MENU',
  POI_CHIPS: 'POI_CHIPS',
};

export const CHANGED_CONDITION: ObjectMapping = {
  UNSET_CHANGED_CONDITION: 'UNSET_CHANGED_CONDITION',
  DATE_RANGE: 'DATE_RANGE',
  GUEST_OR_ROOMS: 'GUEST_OR_ROOMS',
};

export const DEALS_GROUP: ObjectMapping = {
  best_deal: 'BEST_DEALS',
  spring_gateways: 'SPRING_GATEWAYS_DEALS',
  summer_getaways: 'SUMMER_GETAWAYS_DEALS',
  february_getaways: 'FEBRUARY_GETAWAYS_DEALS',
  march_getaways: 'MARCH_GETAWAYS_DEALS',
  april_getaways: 'APRIL_GETAWAYS_DEALS',
  may_getaways: 'MAY_GETAWAYS_DEALS',
  june_getaways: 'JUNE_GETAWAYS_DEALS',
  july_getaways: 'JULY_GETAWAYS_DEALS',
  august_getaways: 'AUGUST_GETAWAYS_DEALS',
  september_getaways: 'SEPTEMBER_GETAWAYS_DEALS',
  october_getaways: 'OCTOBER_GETAWAYS_DEALS',
  november_getaways: 'NOVEMBER_GETAWAYS_DEALS',
  december_getaways: 'DECEMBER_GETAWAYS_DEALS',
};

export const ACTION_IN_SCENE: ObjectMapping = {
  UNSET_ACTION_IN_MODAL_SCREEN: 'UNSET_ACTION_IN_MODAL_SCREEN',
  GO_BACK_DETAIL_PAGE: 'GO_BACK_DETAIL_PAGE',
  GO_BACK_HOME_PAGE: 'GO_BACK_HOME_PAGE',
  REFRESH_PRICE_STAY_CHECKOUT_PAGE: 'REFRESH_PRICE_STAY_CHECKOUT_PAGE',
  CONTINUE_BOOKING: 'CONTINUE_BOOKING',
  CHANGE_ROOM: 'CHANGE_ROOM',
};

export const SCENE_NAMES: ObjectMapping = {
  UNSET_MODAL_SCREEN_NAME: 'UNSET_MODAL_SCREEN_NAME',
  HEADER_RETAIN_MODAL: 'HEADER_RETAIN_MODAL',
  HEADER_RETAIN_IN_BROWSER_MODAL: 'HEADER_RETAIN_IN_BROWSER_MODAL',
  ROOM_CHANGE_RETAIN_MODAL: 'ROOM_CHANGE_RETAIN_MODAL',
  PRICE_HAS_CHANGED_NO_RATE_MODAL: 'PRICE_HAS_CHANGED_NO_RATE_MODAL',
  PRICE_HAS_CHANGED_MODAL: 'PRICE_HAS_CHANGED_MODAL',
  ROOM_UNAVAILABLE_MODAL: 'ROOM_UNAVAILABLE_MODAL',
  CONFIRMED_SCREEN: 'CONFIRMED_SCREEN',
  ACCEPTED_SCREEN: 'ACCEPTED_SCREEN',
  CHECKOUT_SCREEN: 'CHECKOUT_SCREEN',
  NEW_TAB: 'NEW_TAB',
  BOOKING_UNKNOWN_STATUS_MODAL: 'BOOKING_UNKNOWN_STATUS_MODAL',
  CREATE_BOOKING_FAILED_MODAL: 'CREATE_BOOKING_FAILED_MODAL',
  PAYMENT_BACK_FAILED_MODAL: 'PAYMENT_BACK_FAILED_MODAL',
};

export const SAVE_STATUS_TYPE: ObjectMapping = {
  UNSET_SAVE_HOTEL_STATUS: 'UNSET_SAVE_HOTEL_STATUS',
  SAVE_ICON_CLICKED: 'SAVE_ICON_CLICKED',
  SAVE_HOTEL_SUCCESS: 'SAVE_HOTEL_SUCCESS',
  UNSAVED_HOTEL_SUCCESS: 'UNSAVED_HOTEL_SUCCESS',
};

export const HOTEL_MEDIA_TYPE: ObjectMapping = {
  UNSET_HOTEL_MEDIA_TYPE: 'UNSET_HOTEL_MEDIA_TYPE',
  IMAGES: 'IMAGES',
  VIDEO: 'VIDEO',
  TRAVELLER_PHOTOS: 'TRAVELLER_PHOTOS',
};

export const ATYPICAL_DEALS_TYPE: ObjectMapping = {
  UNSET_ATYPICAL_DEALS_TYPE: 'UNSET_ATYPICAL_DEALS_TYPE',
  HOTEL_LEVEL: 'HOTEL_LEVEL',
  DESTINATION_LEVEL: 'DESTINATION_LEVEL',
};

export const PRICE_RANGE_TYPE: ObjectMapping = {
  UNSET_PRICE_RANGE_TYPE: 'UNSET_PRICE_RANGE_TYPE',
  PRICE_LEVEL_LOW: 'LOW',
  PRICE_LEVEL_TYPICAL: 'TYPICAL',
  PRICE_LEVEL_HIGH: 'HIGH',
};

export const TAX_AND_FEE_INCLUSION_POLICY: ObjectMapping = {
  TAX_AND_FEE_INCLUSION_POLICY_UNSPECIFIED: 'UNSET_PRICE_POLICY_TYPE',
  TAX_AND_FEE_INCLUSION_POLICY_TAXES_FEES_NOT_INCLUDED:
    'TAXES_FEES_NOT_INCLUDED',
  TAX_AND_FEE_INCLUSION_POLICY_TAXES_FEES_INCLUDED: 'TAXES_FEES_INCLUDED',
  TAX_AND_FEE_INCLUSION_POLICY_FEES_INCLUDED: 'FEES_INCLUDED',
};

export const AUTOSUGGEST_TELEMETRY_SCHEMA_NAME = 'autosuggest.TelemetryEvent';
export const AUTOSUGGEST_MINIEVENT_NAME = 'AutosuggestTelemetry';

export const SWIPED_DIRECTION: ObjectMapping = {
  UNSET_SWIPED_DIRECTION: 'UNSET_SWIPED_DIRECTION',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};
